import { render, staticRenderFns } from "./LangCom.vue?vue&type=template&id=c3696564&"
import script from "./LangCom.vue?vue&type=script&lang=js&"
export * from "./LangCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports